import React from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";

const PricingModal = ({ show, handleClose, pricing_data, db_type }) => {
    const { t } = useLanguage()

    const extra_gb = "$1/mo per GB"
    const reads_price = "$0,12 per 10.000 ops"
    const writes_price = "$0,29 per 10.000 ops"
    const sql_price = "$0.85 per hour"
    const sql_exp = ""



    const single_write_ops = "$0,000006 per operation"
    const multiple_write_ops = "$0.0000007 per operation"
    const read_ops = "$0.000000015 per operation"


    return (
        <Modal show={show} onHide={handleClose} className="modal_pricing">
            <div className="share_main_cont_modal">

                <p className="share_label">
                    Pricing{" "}
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip className="stripe_tooltip">
                                <p className="tooltip_title">How does pricing work?</p>
                                <p className="tooltip_desc">
                                    After reaching the maximum resource capacity, Erioon can scale, with additional costs applied in predefined blocks. You'll be charged daily directly from your available credit balance or payment method.
                                </p>
                            </Tooltip>
                        }
                    >
                        <i className="fa-solid fa-info"></i>
                    </OverlayTrigger>
                </p>
                <p className="share_label_desc">
                    For more information check out our <strong>pricing plans</strong>
                </p>
                {db_type == "noSQL" ? (
                    <>
                        <div className="modal_body_pricing">
                            <p className="review_cont_data">GB <span>{extra_gb}</span></p>
                            <p className="review_cont_data">Single write operation <span>{single_write_ops}</span></p>
                            <p className="review_cont_data">Batch write operations <span>{multiple_write_ops}</span></p>
                            <p className="review_cont_data">Read operations <span>{read_ops}</span></p>
                            <p className="review_cont_data">We distinguish between single and batch operations because our system is optimized for handling heavy, compute-intensive workloads. Batch operations are priced lower per operation since they require less total computation compared to running them individually.</p>
                            {/* <p className="review_cont_data">Writes <span>{writes_price}</span></p> */}
                        </div>

                    </>
                ) : (
                    <>
                        <div className="modal_body_pricing">

                            {pricing_data == "sqlserver" ? (
                                <>
                                    <p className="review_cont_data">Price <span>From $0.85 per hour</span></p>
                                    <p className="review_cont_data">Storage capacity <span>max 500GB</span></p>
                                    <p className="review_cont_data">Operations <span>Up to 3000 IOPS per vCore</span></p>
                                    <p className="review_cont_data">Backup <span>Geo-redundant backups</span></p>
                                    <p className="review_cont_data">Scalable <span><i className="fa-solid fa-check"></i></span></p>
                                    <p className="review_cont_data">Auto-pause <span>After 1H of inactivity</span></p>
                                </>
                            ) : (
                                <>
                                    <p className="review_cont_data">Price <span>From $0.30 per hour</span></p>
                                    <p className="review_cont_data">Storage capacity <span>max 32TB</span></p>
                                    <p className="review_cont_data">Operations <span>Up to 7500 IOPS per vCore</span></p>
                                    <p className="review_cont_data">Backup <span>Zone redundant backups</span></p>
                                    <p className="review_cont_data">Scalable <span><i className="fa-solid fa-check"></i></span></p>
                                    <p className="review_cont_data">Auto-pause <span><i className="fa-solid fa-x"></i></span></p>
                                </>
                            )}
                        </div>
                    </>
                )}

                <div className="modal_footer">
                    <div className="footer_btn_cont">
                        <button className="cancel_btn" onClick={handleClose}>{t.cancel}</button>
                    </div>
                </div>
            </div>

        </Modal>
    );
};

export default PricingModal;
